<oe-flat-widget [icon]="{name: 'oe-info', size: 'large'}" title="Info">
</oe-flat-widget>
